module.exports = __webpack_public_path__ + "img/footer-logo.8b1d4adc.png";